import React, { useState, useEffect } from "react";
import { Form, Button, Col, ListGroup, Row, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CheckoutSteps from "../components/CheckoutSteps";
import { saveAdjustments } from "../actions/cartActions";

function AdjustmentsScreen({ history }) {
  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const [selection, setSelection] = useState("");

  const [tax, setTax] = useState("");

  const handleSelectionChange = (event) => {
    setSelection(event.target.value);
  };


  // Ensure all prices are numbers and calculate the totals
  const subtotal = cartItems.reduce((acc, item) => {
    const itemTotal = 
    parseFloat(cartItems.reduce((acc, item) => acc + item.qty, 0) * item.tractors.reduce(
      (acc, tractor) => acc + tractor.price, 0
    )); 
    let attachmentsTotal = 0;
    let optionsTotal = 0;

    if (item.attachments) {
      attachmentsTotal = item.attachments.reduce(
        (sum, attachment) => sum + parseFloat(attachment.price),
        0
      );
    }

    if (item.options) {
      optionsTotal = item.options.reduce(
        (sum, option) => sum + parseFloat(option.price),
        0
      );
    }
    
    // Sum the totals for the current item, its attachments, and its options
    return acc + itemTotal + attachmentsTotal + optionsTotal;
  }, 0);

  const attachmentsTotalPrice = cartItems.reduce((acc, item) => {
    const attachmentsPrice = item.attachments
      ? item.attachments.reduce(
          (sum, attachment) => sum + (parseFloat(attachment.price) || 0),
          0
        )
      : 0;
    return acc + attachmentsPrice;
  }, 0);

  const optionsTotalPrice = cartItems.reduce((acc, item) => {
    const optionsPrice = item.options
      ? item.options.reduce(
          (sum, option) => sum + (parseFloat(option.price) || 0),
          0
        )
      : 0;
    return acc + optionsPrice;
  }, 0);

  const [markup, setMarkup] = useState(0);
  const [margin, setMargin] = useState(0);



  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(saveAdjustments({ selection, markup, margin, tax }));
    history.push("/configure");
  };

  useEffect(() => {
    if (!userInfo) {
      history.push("/login");
    } else if (cartItems.length === 0 || cartItems.length > 1) {
      history.push("/cart");
    }
  }, [history, userInfo, cartItems]);

  useEffect(() => {
    if (userInfo) {
      setMarkup(userInfo.markup);
    }
    if (userInfo) {
      setMargin(userInfo.margin);
    }
    if (userInfo) {
      setTax(userInfo.tax);
    }
  }, [userInfo]);

  return (
    <Container>
      <CheckoutSteps step1 />

      <Row>
        <Col md={4} className="order-md-2 mb-4">
          <h4 className="summaryTitle">Summary</h4>
          <ListGroup className="mb-3">
            <ListGroup.Item
              style={{
                borderRadius: "10px 10px 0px 0px",
              }}
            >
              <Row>
                <Col>Tractor:</Col>
                <Col>
                  <span className="price style1">
                    $
                    {parseFloat( cartItems.reduce((acc, item) => acc + item.qty, 0) * cartItems.reduce(
                      (acc, item) => acc + item.tractors.reduce(
                        (acc, tractor) => acc + tractor.price, 0
                      ), 0
                    )).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}

                  </span>
                </Col>
              </Row>
            </ListGroup.Item>

            {userInfo ? (
              <ListGroup.Item>
                <Row>
                  <Col>Attachments:</Col>
                  <Col>
                    <span className="price style1">
                      $
                      {attachmentsTotalPrice.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </Col>
                </Row>
              </ListGroup.Item>
            ) : (
              <span></span>
            )}
            {userInfo ? (
              <ListGroup.Item>
                <Row>
                  <Col>Options:</Col>
                  <Col>
                    <span className="price style1">
                      $
                      {optionsTotalPrice.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </Col>
                </Row>
              </ListGroup.Item>
            ) : (
              <span></span>
            )}
            {userInfo ? (
              <ListGroup.Item
              style={{
                borderRadius: "0px 0px 10px 10px",
              }}
              >
                <Row>
                  <Col>
                    Total Net:
                  </Col>
                  <Col>
                    <span className="price style2">
                      $
                      {subtotal.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </Col>
                </Row>
              </ListGroup.Item>
            ) : (
              <span></span>
            )}

            
            
          </ListGroup>
        </Col>

        {/* Adjustments section */}

        <Col md={8} className="order-md-1">
          <div className="py-3 text-center">
            <h1 className="header">Adjustments and Options</h1>
            <p className="smallDescription">
              Feel free to modify options, adjust the markup and margin gains,
              or update the state tax. Please note, this section is exclusively
              for dealers.
            </p>
          </div>
          <Form onSubmit={submitHandler}>
            <Form.Group controlId="selection">
              <Form.Label className="labeldropdown">Choose Option</Form.Label>
              <Form.Control
                className="dropdown adjust"
                as="select"
                value={selection}
                // onChange={(e) => setSelection(e.target.value)}
                onChange={handleSelectionChange}
              >
                <option value="">-- Select --</option>
                <option value="markup">Markup</option>
                <option value="margin">Margin</option>
              </Form.Control>

              <hr
                style={{
                  width: "100%",
                  margin: "1rem 0",
                  marginBottom: "2rem",
                }}
              />
            </Form.Group>
            {/* MARKUP SECTION */}
            {selection === "markup" && (
              <>
                <Form.Group
                  as={Col}
                  md="12"
                  className="group space"
                  controlId="markupGain"
                >
                  <div class="row mb-3 text-center">
                    <div class="col-md-3 themed-grid-col">
                      <Form.Label className="label">Markup Gain</Form.Label>
                    </div>
                    <div class="col-md-6 themed-grid-col">
                      <Form.Control
                        className="input adjust range "
                        type="range"
                        step="0.01"
                        min="0"
                        max="100"
                        value={markup}
                        onChange={(e) => setMarkup(e.target.value)}
                        defaultValue={0}
                      />
                    </div>
                    <div class="col-md-3 themed-grid-col">
                      <Form.Control
                        className="input adjust "
                        type="number"
                        step="0.01"
                        min="0"
                        max="100"
                        required
                        value={markup}
                        onChange={(e) => setMarkup(e.target.value)}
                        defaultValue={0}
                      />
                    </div>
                  </div>
                </Form.Group>

                <Form.Group
                  as={Col}
                  md="12"
                  className="group space"
                  controlId="tax"
                >
                  <div class="row mb-3 text-center ">
                    <div class="col-md-3 themed-grid-col">
                      <Form.Label className="label">State Tax</Form.Label>
                    </div>
                    <div class="col-md-2 themed-grid-col">
                      <Form.Control
                        className="input adjust"
                        type="number"
                        step="0.01"
                        max="100"
                        min="0"
                        required
                        value={tax}
                        onChange={(e) => setTax(e.target.value)}
                      />
                    </div>
                  </div>
                </Form.Group>
              </>
            )}
            {/* MARGIN SECTION */}
            {selection === "margin" && (
              <>
                <Form.Group
                  as={Col}
                  md="12"
                  className="group space"
                  controlId="marginGain"
                >
                  <div class="row mb-3 text-center">
                    <div class="col-md-3 themed-grid-col">
                      <Form.Label className="label">Margin Gain</Form.Label>
                    </div>
                    <div class="col-md-6 themed-grid-col">
                      <Form.Control
                        className="input adjust range "
                        type="range"
                        step="0.01"
                        min="0"
                        max="100"
                        value={margin}
                        onChange={(e) => setMargin(e.target.value)}
                        defaultValue={0}
                      />
                    </div>
                    <div class="col-md-3 themed-grid-col">
                      <Form.Control
                        className="input adjust"
                        type="number"
                        step="0.01"
                        min="0"
                        max="100"
                        required
                        value={margin}
                        onChange={(e) => setMargin(e.target.value)}
                        defaultValue={0}
                      />
                    </div>
                  </div>
                </Form.Group>

                <Form.Group
                  as={Col}
                  md="12"
                  className="group space"
                  controlId="tax"
                >
                  <div class="row mb-3 text-center ">
                    <div class="col-md-3 themed-grid-col">
                      <Form.Label className="label">State Tax</Form.Label>
                    </div>
                    <div class="col-md-2 themed-grid-col">
                      <Form.Control
                        className="input adjust"
                        type="number"
                        step="0.01"
                        max="100"
                        min="0"
                        required
                        value={tax}
                        onChange={(e) => setTax(e.target.value)}
                      />
                    </div>
                  </div>
                </Form.Group>
              </>
            )}
            <br></br>
            <div className="py-5 text-center">
              <Button
                className="button adjust"
                type="submit"
                variant="primary"
                disabled={!margin && !markup}
              >
                Continue
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default AdjustmentsScreen;
